module.exports = "/_next/static/images/CompanyOverview-2x-1bf04abe1d8dbb3677c27e64ad249b97.jpg.webp";